import { utcDateKey } from '../analytics/circle-revenue-analytics';

export type DailyAnalyticsPoint = {
  date: string;
  value: number;
};

export type CompletionFunnelStage = {
  stage: 'enrolled' | 'started' | 'halfway' | 'completed';
  label: string;
  count: number;
  rate: number;
};

function startOfUtcDay(date: Date): Date {
  const next = new Date(date);
  next.setUTCHours(0, 0, 0, 0);
  return next;
}

export function buildDailyCountSeries30d(
  items: Array<{ date: string }>,
): DailyAnalyticsPoint[] {
  const now = startOfUtcDay(new Date());
  const start = new Date(now);
  start.setUTCDate(start.getUTCDate() - 29);

  const counts = new Map<string, number>();
  for (const item of items) {
    counts.set(item.date, (counts.get(item.date) ?? 0) + 1);
  }

  return Array.from({ length: 30 }, (_, index) => {
    const date = new Date(start);
    date.setUTCDate(start.getUTCDate() + index);
    const key = utcDateKey(date);
    return { date: key, value: counts.get(key) ?? 0 };
  });
}

export function buildDailySumSeries30d(
  items: Array<{ date: string; amountCents: number }>,
): DailyAnalyticsPoint[] {
  const now = startOfUtcDay(new Date());
  const start = new Date(now);
  start.setUTCDate(start.getUTCDate() - 29);

  const totals = new Map<string, number>();
  for (const item of items) {
    totals.set(item.date, (totals.get(item.date) ?? 0) + item.amountCents);
  }

  return Array.from({ length: 30 }, (_, index) => {
    const date = new Date(start);
    date.setUTCDate(start.getUTCDate() + index);
    const key = utcDateKey(date);
    return { date: key, value: totals.get(key) ?? 0 };
  });
}

export function computeCompletionFunnel(params: {
  totalEnrollments: number;
  startedCount: number;
  halfwayCount: number;
  completedCount: number;
}): CompletionFunnelStage[] {
  const total = params.totalEnrollments;
  const pct = (count: number) => (total > 0 ? Math.round((count / total) * 1000) / 10 : 0);

  return [
    { stage: 'enrolled', label: 'Enrolled', count: total, rate: total > 0 ? 100 : 0 },
    { stage: 'started', label: 'Started learning', count: params.startedCount, rate: pct(params.startedCount) },
    { stage: 'halfway', label: '50%+ progress', count: params.halfwayCount, rate: pct(params.halfwayCount) },
    { stage: 'completed', label: 'Completed', count: params.completedCount, rate: pct(params.completedCount) },
  ];
}
